import { Component, OnInit, forwardRef, ViewContainerRef, ViewChild, ElementRef, TemplateRef, Host, HostListener, OnDestroy, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';

import { TranslateService } from '@ngx-translate/core';
import { mmTableConstants } from '../../../table/mm-table-constants';
import { mmI18nConstants } from '../../i18n-constants';
import { tr } from 'date-fns/locale';
import { MmTranslateService } from '../../translate.service';

import { Overlay, OverlayConfig, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal, CdkPortal } from '@angular/cdk/portal';
import { I18nTranslations } from 'mm-web-core/i18n/i18n-translations';
import { NzTableComponent } from 'ng-zorro-antd/table';

function isElemntOf(a: HTMLElement, b: HTMLElement) {
  if (a == b) return true;
  if (!a.parentElement) return false;
  if (a.parentElement == b) return true;
  return isElemntOf(a.parentElement, b);
}
@Component({
  selector: 'mm-i18n-text',
  templateUrl: './i18n-text-input.component.html',
  styleUrls: ['./i18n-text-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => I18nTextInputComponent),
      multi: true
    }
  ]
})
export class I18nTextInputComponent implements OnInit, ControlValueAccessor, OnDestroy {

  @Input() maxlength=null;
  value: { [key: string]: string } = {}
  temp: { [key: string]: string } = {}

  cultures = ['en', 'zh'];
  onChange: (_: any) => void;
  writeValue(obj: any): void {
    this.value = obj || {}

  }
  registerOnChange(fn: any): void {
    this.onChange = fn;

  }
  registerOnTouched(fn: any): void {

  }
  setDisabledState?(isDisabled: boolean): void {

  }

  constructor(
    private translateService: MmTranslateService,
    private viewContainerRef: ViewContainerRef,
    private elementRef: ElementRef,
    public translations: I18nTranslations,

    private overlay: Overlay) { }
  ngOnDestroy(): void {
    if (this.overlayRef) {
      this.overlayRef.detach();
      delete this.overlayRef;
    }
  }

  ngOnInit(): void {
    this.cultures = this.translateService.supportedLangs;
  }

  getText(cul: string) {
    return this.value[cul];
  }

  get current() {
    return this.value[localStorage.getItem("lang")];
  }

  private overlayRef: OverlayRef

  width: string;
  @ViewChild("textInput", { static: true })
  textInput: ElementRef;
  edit() {
    if (!this.overlayRef) {
      this.width = `${(this.textInput.nativeElement as HTMLElement).clientWidth + 45}px`;
      var strategy = this.overlay.position().flexibleConnectedTo(this.textInput.nativeElement)
        .withPositions([{ originX: "start", originY: "top", overlayX: "start", overlayY: "top", offsetX: -13, offsetY: -7 }])
      var config = new OverlayConfig({
        positionStrategy: strategy,
        disposeOnNavigation: true
      });
      this.overlayRef = this.overlay.create(config);
      this.overlayRef.attach(this.template);
    }
  }
  mode: "edit" | "view" = "view";

  @ViewChild("overlayGlobalTemplate", { static: true })
  template: CdkPortal;

  isEditing: boolean = false;


  tanslate(cul: string) {
    return this.translateService.get(`Language.${cul} `)
  }

  resovleKey(key: string) {
    return `${mmI18nConstants.translationGroup}.${key} `

  }
  @ViewChild(NzTableComponent, { static: false })
  table: ElementRef;
  @HostListener("document:click", ["$event"])
  onClick(e: MouseEvent) {
    var host = this.elementRef.nativeElement as HTMLElement;
    if (!isElemntOf(e.target as HTMLElement, this.textInput.nativeElement)
      && this.overlayRef && !isElemntOf(e.target as HTMLElement, this.overlayRef.overlayElement)
    ) {
      if (this.overlayRef) {
        this.overlayRef.detach();
        delete this.overlayRef;
      }

    }
    // if (!isElemntOf(e.target as HTMLElement, host)) {
    //   this.mode = "view";
    // }
  }

  setText(cul: string, text: string) {
    // if (text) {
    //   text = text.trim();
    // }
    this.temp[cul] = text;
    this.commit();
  }

  commit() {
    this.value = {
      ...this.value,
      ...this.temp
    }
    this.onChange(this.value);
  }

  inputKeydown(e: KeyboardEvent) {

    if (e.key == "Enter") {
      if (this.overlayRef) {
        this.overlayRef.detach();
        this.overlayRef = undefined;
      }

    }

  }

  // @HostListener("keydown", ["$event"])
  // keydown(e: KeyboardEvent) {
  //   if (e.key == "Esc" && this.overlayRef) {
  //     this.overlayRef.detach();
  //     this.overlayRef = undefined;
  //     e.preventDefault();
  //     e.stopPropagation();
  //   }
  // }
}
